import * as Yup from 'yup'
import { differenceInYears, format as fnsFormat, isFuture } from 'date-fns'

Yup.addMethod(
  Yup.string,
  'dateFormat',
  function dateFormat(formats, dateSeparator, message) {
    return this.test('testFormat', message, (value) => {
      if (value) {
        const date = value.split(dateSeparator)
        return (
          value ===
          fnsFormat(
            new Date(Number(date[2]), Number(date[1]) - 1, Number(date[0])),
            formats
          )
        )
      }
      return true
    })
  }
)

// Alias utrzymuje zgodnosc wsteczna ze starymi schematami IE.
Yup.addMethod(
  Yup.string,
  'formatOfDate',
  function formatOfDate(formats, dateSeparator, message) {
    return this.dateFormat(formats, dateSeparator, message)
  }
)

Yup.addMethod(
  Yup.string,
  'fullAge',
  function fullAge(years, dateSeparator, message) {
    return this.test('testAge', message, (value) => {
      if (value) {
        const date = value.split(dateSeparator)
        return (
          differenceInYears(
            new Date(),
            new Date(Number(date[2]), Number(date[1]) - 1, Number(date[0]))
          ) >= years
        )
      }
      return true
    })
  }
)

Yup.addMethod(
  Yup.string,
  'notInFuture',
  function notInFuture(dateSeparator, message) {
    return this.test('testAge', message, (value) => {
      if (value) {
        const date = value.split(dateSeparator)
        return !isFuture(
          new Date(Number(date[2]), Number(date[1]) - 1, Number(date[0]))
        )
      }
      return true
    })
  }
)

Yup.addMethod(
  Yup.string,
  'minValue',
  function minValue(message, minValueParam) {
    return this.test('testMin', message, (value) => {
      if (!value) {
        return true
      }
      return parseFloat(value.replace(/,/g, '.')) >= minValueParam
    })
  }
)

Yup.addMethod(
  Yup.string,
  'maxValue',
  function maxValue(message, maxValueParam) {
    return this.test('testMax', message, (value) => {
      if (!value) {
        return true
      }
      return parseFloat(value.replace(/,/g, '.')) <= maxValueParam
    })
  }
)

Yup.addMethod(Yup.string, 'atLeastOneOf', function atLeastOneOf(list, message) {
  return this.test(
    'testAtLeastOneOf',
    message,
    function testAtLeastOneOf(value) {
      if (value === undefined) {
        return list.some((item) => this.parent[item] !== undefined)
      }
      return true
    }
  )
})

export default Yup
